module.exports = __webpack_public_path__ + "assets/img/typeIcon-2-red.1986882f.svg";